/**
 * Monday-to-Sunday of the week containing `today`, in UTC.
 *
 * "This week" as a person means the calendar week, not the next seven days — and read in UTC so the
 * window matches the one Zocdoc is asked to filter on (`start_time_utc_min` / `_max`).
 *
 * Its own module rather than a named export from the card: a component file that also exports a
 * function loses React fast refresh.
 */
export function thisWeek(today = new Date()): { fromDay: string; toDay: string } {
  const monday = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()))
  // getUTCDay() is 0 for Sunday, which belongs to the week that started six days earlier.
  const shift = (monday.getUTCDay() + 6) % 7
  monday.setUTCDate(monday.getUTCDate() - shift)
  const sunday = new Date(monday)
  sunday.setUTCDate(sunday.getUTCDate() + 6)
  return {
    fromDay: monday.toISOString().slice(0, 10),
    toDay: sunday.toISOString().slice(0, 10),
  }
}

/**
 * The calendar days a calendar view covers, as the card's window.
 *
 * Read in the **browser's** zone, unlike `thisWeek`: the range is the days the person sees on the
 * Schedule grid, which starts at local midnight — in UTC that is the previous evening east of
 * Greenwich, and the window would open a day early. `end` is exclusive, as FullCalendar reports it.
 */
export function viewDays(range: { start: Date; end: Date }): { fromDay: string; toDay: string } {
  const day = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  const lastDay = new Date(range.end)
  lastDay.setDate(lastDay.getDate() - 1)
  return { fromDay: day(range.start), toDay: day(lastDay) }
}
